<template>
  <div class="info">
    <ActiveKit
      v-show="activeStep === 0"
      @nextStep="nextStep"
      @prevStep="prevStep"
    ></ActiveKit>
    <CreateProfile
      v-if="activeStep === 1"
      @nextStep="nextStep"
      @prevStep="prevStep"
    ></CreateProfile>
    <Notification
      v-show="activeStep === 2"
      :notificationData="notificationData"
      @nextStep="nextStep"
      @prevStep="prevStep"
    ></Notification>
    <SimplingDetails
      v-show="activeStep === 3"
      @nextStep="nextStep"
      @prevStep="prevStep"
    ></SimplingDetails>
    <Review
      v-if="activeStep === 4"
      @nextStep="nextStep"
      @showTerms="showTerms"
      @prevStep="prevStep"
    ></Review>
    <Instructions
      v-if="activeStep === 5"
      @nextStep="nextStep"
      @prevStep="prevStep"
    ></Instructions>
    <ShareReport
      v-if="activeStep === 6"
      @nextStep="nextStep"
      @showTerms="showTerms"
      @showPrivecy="showPrivecy"
      @prevStep="prevStep"
    ></ShareReport>
    <FinalStep
      v-if="activeStep === 7"
      @nextStep="nextStep"
      @showTerms="showTerms"
      @showPrivecy="showPrivecy"
      @prevStep="prevStep"
    ></FinalStep>
  </div>
</template>
<script>
import ActiveKit from "./steps/ActiveKit";
import CreateProfile from "./steps/CreateProfile";
import SimplingDetails from "./steps/SimplingDetails";
import Review from "./steps/Review";
import Notification from "./steps/Notification";
import FinalStep from "./steps/FinalStep";
import ShareReport from "./steps/ShareReport";
import Instructions from "./steps/Instructions";

export default {
  name: "StepsInfo",
  props: ["activeStep"],
  data() {
    return {
      notificationData: null
    };
  },
  components: {
    Notification,
    ActiveKit,
    CreateProfile,
    SimplingDetails,
    Review,
    FinalStep,
    Instructions,
    ShareReport
  },
  methods: {
    showTerms() {
      this.$emit("showTerms", true);
    },
    showPrivecy() {
      this.$emit("showPrivecy", true);
    },
    nextStep(e) {
      this.$emit("nextStep", e);
    },
    prevStep(e) {
      if (e.notificationData) {
        this.notificationData = e.notificationData;
        this.$emit("prevStep", e.step);
      } else {
        this.$emit("prevStep", e);
      }
    }
  }
};
</script>

<style scoped></style>
